

var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/redux-form/es/util/getDisplayName.js
// module id = 572
// module chunks = 0 1 2 3 4 5 6 7 8 9 10